let setLoadingFn: ((loading: boolean) => void) | null = null;
let suppressGlobalLoader = false;

export const registerSetLoading = (fn: (loading: boolean) => void) => {
    setLoadingFn = fn;
};

export const setGlobalLoading = (loading: boolean) => {
    if (!suppressGlobalLoader && setLoadingFn) {
        setLoadingFn(loading);
    }
};

export const suppressLoaderOnce = () => {
    suppressGlobalLoader = true;

    // Automatically reset after one event loop tick (or short delay)
    setTimeout(() => {
        suppressGlobalLoader = false;
    }, 0);
};
